module.exports = "/assets/data/a4d590a0c42e68305e3aff644e8761e6-WS9.data.json";